// @ts-nocheck
import { CartAddEvent } from '@theme/events';

const CUSTOM_DOZEN_VARIANT_ID = window.location.href.includes("georgetown-cupcake-development.myshopify.com") ? "41451295047813" : '47500743114979';

class Flavors extends HTMLElement {
    constructor() {
      super();
      this.pendingRetries = new WeakMap();
      this.init();
    }

    init() {
        this.elementsList = '';
        this.flavorsContainer = document.getElementById('flavors-container');
        this.container = this.querySelector('#flavors-list');
        this.sortSelect = this.querySelector('#sort');
        this.flavorProfilesSelect = this.querySelector('#flavor-profiles');
        this.deliveryDateEl = document.querySelector('.js-delivery-date');
        this.deliveryZipEl = document.querySelector('.js-delivery-zip');
        this.deliveryTimeEl = document.querySelector('.js-time');
        this.deliveryLocalLocationEl = document.querySelector('.js-location');
        this.flavorProfilesContainer = this.querySelector('#flavor-profiles-container');
        this.builderContent = this.querySelector('.js-builder-content');
        this.addToCartBtn = this.querySelector('.js-add-bundle');
        this.clearBtn = this.querySelector('.js-builder-clear');
        this.type = localStorage.getItem('delivery-ship-type');
        this.cartTypeElement = document.querySelector('[data-cart-type]');
        this.inventoryPopup = document.querySelector('.js-popup-inventory');
        this.today = new Date().toLocaleDateString('en-GB', { 
            day: '2-digit',
            month: 'long', 
            year: 'numeric' 
        });

        this.sortBy = 'manual';
        this.flavorProfile = '';
        this.maxItemsToShow = parseInt(this.flavorsContainer?.dataset.visibleItems) || 16;
        this.allItems = '';
        this.isInitialLoad = true;
    
        this.domParser = new DOMParser();

        // Get block settings from data attributes
        this.blockSettings = {
            1: {
                title: this.flavorsContainer?.getAttribute('data-title-1') || 'Everyday Classics',
                disableShowMore: this.flavorsContainer?.getAttribute('data-disable-show-more-1') === 'true'
            },
            2: {
                title: this.flavorsContainer?.getAttribute('data-title-2') || 'Daily Favorites',
                disableShowMore: this.flavorsContainer?.getAttribute('data-disable-show-more-2') === 'true'
            },
            3: {
                title: this.flavorsContainer?.getAttribute('data-title-3') || 'Seasonal Favorites',
                disableShowMore: this.flavorsContainer?.getAttribute('data-disable-show-more-3') === 'true'
            }
        };

        // Initialize blocks structure
        this.blocks = [];

        this.setSelectedDate();
        this.handleRemoveFlavor();
        this.initStickyBuilder();
        this.initTooltips();
        this.initializeBlocks();
        this.handleQtyChanged(); // Initialize event delegation for quantity buttons
        
        document.addEventListener('delivery-changed', () => this.handleDeliveryDateChange());
        //document.addEventListener('flavor-changed', () => this.checkBundle());
        this.sortSelect.addEventListener('change', () => this.handleSortChange());
        this.flavorProfilesSelect.addEventListener('change', () => this.handleFlavorProfileChange());
        if(this.clearBtn) {
            this.clearBtn.addEventListener('click', () => this.handleClear(true));
        }
        if(this.addToCartBtn) {
            this.addToCartBtn.addEventListener('click', () => this.handleAddToCart());
        }
   
        this.sortSlimSelect = new SlimSelect({
            select: '#sort',
            settings: {
              showSearch: false,
            },
        });
        
        this.selectedFlavors = {};
        this.getList();


        if(this.querySelector('.js-view-your-box')) {
            const toggleButton = this.querySelector('.js-view-your-box');
      
            toggleButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleViewYourBox();
            });

            toggleButton.addEventListener('touchend', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleViewYourBox();
            });
            
            if (!toggleButton.hasAttribute('tabindex')) {
                toggleButton.setAttribute('tabindex', '0');
            }
            
            this.initToggleButtonObserver();
            
            window.addEventListener('resize', () => {
                if (this.toggleObserver) {
                    this.toggleObserver.disconnect();
                }
                this.initToggleButtonObserver();
            });
        }
        this.validateAddToCart();
        if(this.inventoryPopup) {
           this.setInventoryPopup();
        }
    }

    initializeBlocks() {
        // Find the pagination container
        const paginationContainer = this.querySelector('.pagination__container');
        if (!paginationContainer) return;
        
        // Find the original flavors list
        const flavorsList = this.container;
        
        // Check if all titles are empty - if so, don't create blocks
        const allTitlesEmpty = !this.blockSettings[1].title && !this.blockSettings[2].title && !this.blockSettings[3].title;
        
        if (allTitlesEmpty) {
            // Don't create blocks, use original list
            this.useOriginalList = true;
            return;
        }
        
        this.useOriginalList = false;
        
        // Create blocks structure for 3 blocks
        for (let i = 1; i <= 3; i++) {
            const blockWrapper = document.createElement('div');
            blockWrapper.className = 'flavors-list__block';
            blockWrapper.id = `flavors-block-${i}`;
            
            const blockTitle = document.createElement('h3');
            blockTitle.className = 'flavors-list__block-title';
            blockTitle.textContent = this.blockSettings[i].title;
            
            const blockContent = document.createElement('div');
            blockContent.className = 'flavors-list__block-content product-grid';
            blockContent.id = `flavors-block-content-${i}`;
            
            const showMoreContainer = document.createElement('div');
            showMoreContainer.className = 'show-more__container';
            showMoreContainer.id = `show-more-container-${i}`;
            showMoreContainer.style.display = 'none';
            
            const showMoreBtn = document.createElement('button');
            showMoreBtn.className = 'show-more__btn button mtn-button--primary';
            showMoreBtn.textContent = 'Show More';
            showMoreBtn.type = 'button';
            showMoreBtn.addEventListener('click', () => this.showMoreItems(i));
            
            showMoreContainer.appendChild(showMoreBtn);
            
            blockWrapper.appendChild(blockTitle);
            blockWrapper.appendChild(blockContent);
            
            if (!this.blockSettings[i].disableShowMore) {
                blockWrapper.appendChild(showMoreContainer);
            }
            
            // Insert blocks before the flavors-list ul element
            paginationContainer.insertBefore(blockWrapper, flavorsList);
            
            this.blocks.push({
                index: i,
                element: blockContent,
                showMoreContainer: !this.blockSettings[i].disableShowMore ? showMoreContainer : null,
                showMoreBtn: !this.blockSettings[i].disableShowMore ? showMoreBtn : null,
                title: this.blockSettings[i].title
            });
        }
        
        // Hide the original container
        if (this.container) {
            this.container.style.display = 'none';
        }
    }

    handleDeliveryDateChange() {
        this.setSelectedDate();
        this.getList();
        this.validateAddToCart();
    }
        
    setSelectedDate() {
        const dateValue = this.deliveryDateEl?.value?.length > 0 ? this.deliveryDateEl.value : localStorage.getItem('delivery-date');
        if(dateValue && dateValue.length > 0) {
            this.selectedDate = dateValue;
            const dateParts = this.selectedDate.split(' ');
            this.selectedDay = dateParts[0];
            this.selectedMonth = dateParts[1];
            this.selectedYear = dateParts[2];
            const date = new Date(`${this.selectedMonth} ${this.selectedDay}, ${this.selectedYear}`);
            this.dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' });
        }  
    }
    
    setOutOfStock() {
        if (this.today !== this.selectedDate) {
            return;
        }
        
        const elementsName = this.deliveryLocalLocationEl.value === 'georgetown' ? 'data-inventory-georgetown' : 'data-inventory-bethesda';
        const outOfStockElements = document.querySelectorAll(`.flavors-list__container [${elementsName}="0"]`);
      
        outOfStockElements.forEach(element => {
            element.closest('.product-card').classList.add('product-card--sold-out');
        });
    }

    getTotalItemsCount(html) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.children.length;
    }

    handleSortChange() {
        this.sortBy = this.sortSelect.value;
        this.getList(false);
    }

    getList(updateBundle = true) {
        this.setLoading();
        const self = this;
        let dayPromise;

        const collectionFilterURL = new URL('/collections/flavors', window.location.origin);
        collectionFilterURL.searchParams.set('section_id', 'main-collection-flavor');
        if(self.flavorProfile) {
            collectionFilterURL.searchParams.set('filter.p.m.custom.flavor_profile', self.flavorProfile);
        }
        collectionFilterURL.searchParams.set('sort_by', self.sortBy);

        const collectionByDayURL = new URL(collectionFilterURL.toString());
        collectionByDayURL.searchParams.set('filter.p.m.global.background_filter_month', self.selectedMonth);
        collectionByDayURL.searchParams.append('filter.p.m.global.background_filter_month', 'Year Round');
        if (this.type === 'local') {
            collectionByDayURL.searchParams.set('filter.p.m.global.background_filter_day', self.dayOfWeek);
        } else {
            ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].forEach(i => {
                collectionByDayURL.searchParams.append('filter.p.m.global.background_filter_day', i);
            });
        }

        const collectionByMonthURL = new URL(collectionFilterURL.toString());
        collectionByMonthURL.searchParams.set('filter.p.m.global.background_filter_month', self.selectedMonth);
        if (this.type === 'local') {
            collectionByMonthURL.searchParams.set('filter.p.m.global.background_filter_day', self.dayOfWeek);
            collectionByMonthURL.searchParams.append('filter.p.m.global.background_filter_day', 'AllDays');
        } else {
            ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'AllDays'].forEach(i => {
                collectionByMonthURL.searchParams.append('filter.p.m.global.background_filter_day', i);
            });
        }

        const collectionEveryDayAndEveryMonthURL = new URL(collectionFilterURL.toString());
        collectionEveryDayAndEveryMonthURL.searchParams.set('filter.p.m.global.background_filter_day', 'AllDays');
        collectionEveryDayAndEveryMonthURL.searchParams.set('filter.p.m.global.background_filter_month', 'Year Round');
        collectionEveryDayAndEveryMonthURL.searchParams.set('filter.p.m.global.category', 'Everyday Classic');

        const promises = [
            fetch(collectionEveryDayAndEveryMonthURL.toString()).then(r => r.text()),
            fetch(collectionByDayURL.toString()).then(r => r.text()),
            fetch(collectionByMonthURL.toString()).then(r => r.text()),
        ];

        Promise.all(promises)
            .then(([htmlClassic, htmlDay, htmlMonth]) => {
              const monthDoc = this.domParser?.parseFromString(htmlMonth, 'text/html');
              const dayDoc = this.domParser?.parseFromString(htmlDay, 'text/html');
              const classicDoc = this.domParser?.parseFromString(htmlClassic, 'text/html');

              if (!monthDoc || !dayDoc || !classicDoc) {
                console.error('Failed to parse HTML documents');
                return;
              }
              
              const monthEl = monthDoc.querySelector('#in-stock-list');
              const dayEl = dayDoc.querySelector('#in-stock-list');
              const classicEl = classicDoc.querySelector('#in-stock-list');
           
              
              const monthList = monthEl?.innerHTML || '';
              const dayList = dayEl?.innerHTML || '';
              const classicList = classicEl?.innerHTML || '';
              
              const monthProfiles = monthDoc.querySelector('#flavor-profiles-values')?.getAttribute('data-flavor-profiles') || '';
              const dayProfiles = dayDoc.querySelector('#flavor-profiles-values')?.getAttribute('data-flavor-profiles') || '';
              const classicProfiles = classicDoc.querySelector('#flavor-profiles-values')?.getAttribute('data-flavor-profiles') || '';
              
              const allProfiles = [monthProfiles, dayProfiles, classicProfiles]
                .filter(profile => profile)
                .join(',');
              
              this.flavorProfiles = [...new Set(allProfiles.split(',')
                .map(profile => profile.trim())
                .filter(profile => profile !== ''))]
                .join(',');
        
              // If all titles are empty, render all products in original list
              if (this.useOriginalList) {
                const combinedList = classicList + dayList + monthList;
                this.renderOriginalList(combinedList);
              } else {
                // Populate each block with its corresponding data
                if (self.type === 'local'){
                  this.renderBlock(1, classicList);  // Block 1: Classics
                  this.renderBlock(2, dayList);      // Block 2: Daily
                  this.renderBlock(3, monthList);    // Block 3: Seasonal
                } else {
                  this.renderBlock(1, classicList);  // Block 1: Classics
                  this.renderBlock(2, dayList);    // Block 2: Monthly
                  this.renderBlock(3, monthList);      // Block 3: Daily
                }
              }
              
              if(updateBundle){ 
                this.handleClear(false)
                this.resetFlavors();
              } else {
                // Restore quantities after filtering
                this.restoreQuantitiesAfterFilter();
              }
              
              this.addSelectOptions();
              this.applyHiddenPopularityFilter();
            })
            .catch(error => console.error('Error loading sections:', error))
            .finally(() => this.removeLoading());
    }

    renderBlock(blockIndex, htmlContent) {
        const block = this.blocks.find(b => b.index === blockIndex);
        if (!block) return;

        const blockWrapper = block.element.closest('.flavors-list__block');
        const blockTitle = blockWrapper?.querySelector('.flavors-list__block-title');

        if (!htmlContent) {
            block.element.innerHTML = '';
            if (block.showMoreContainer) {
                block.showMoreContainer.style.display = 'none';
            }
            if (blockTitle) {
                blockTitle.style.display = 'none';
            }
            return;
        }

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        let items = Array.from(tempDiv.querySelectorAll('.product-grid__item'));

        if (items.length === 0) {
            block.element.innerHTML = '';
            if (block.showMoreContainer) {
                block.showMoreContainer.style.display = 'none';
            }
            if (blockTitle) {
                blockTitle.style.display = 'none';
            }
            return;
        }

        // Show title if there are items
        if (blockTitle) {
            blockTitle.style.display = '';
        }

        // Sort items by sort number only if sort is default (manual)
        if (this.sortBy === 'manual') {
            items = this.sortProductItemsByNumber(items);
        }

        const effectiveMaxItems = block.showMoreContainer ? this.maxItemsToShow : 999;

        if (items.length <= effectiveMaxItems) {
            // Show all items
            const visibleItems = items.slice(0, effectiveMaxItems);
            block.element.innerHTML = '';
            visibleItems.forEach(item => block.element.appendChild(item));
            
            if (block.showMoreContainer) {
                block.showMoreContainer.style.display = 'none';
            }
        } else {
            // Hide items beyond maxItems
            const visibleItems = items.slice(0, effectiveMaxItems);
            const hiddenItems = items.slice(effectiveMaxItems);

            hiddenItems.forEach(item => {
                item.style.display = 'none';
                item.classList.add('flavors-list__hidden-item');
            });
            
            block.element.innerHTML = '';
            const allItems = [...visibleItems, ...hiddenItems];
            allItems.forEach(item => block.element.appendChild(item));

            if (block.showMoreContainer && block.showMoreBtn) {
                block.showMoreContainer.style.display = 'flex';
                block.showMoreBtn.textContent = `Show More`;
            }
        }
    }

    renderOriginalList(htmlContent) {
        if (!this.container) return;
        
        if (!htmlContent) {
            this.container.innerHTML = '';
            return;
        }

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        let items = Array.from(tempDiv.querySelectorAll('.product-grid__item'));

        if (items.length === 0) {
            this.container.innerHTML = '';
            return;
        }

        // Sort items by sort number only if sort is default (manual)
        if (this.sortBy === 'manual') {
            items = this.sortProductItemsByNumber(items);
        }

        // Clear and append all items
        this.container.innerHTML = '';
        items.forEach(item => this.container.appendChild(item));
    }

    sortProductItemsByNumber(items) {
        return items.sort((a, b) => {
            const cardA = a.querySelector('.product-card-wrapper');
            const cardB = b.querySelector('.product-card-wrapper');
            
            const sortNumberA = cardA?.dataset.sortNumber;
            const sortNumberB = cardB?.dataset.sortNumber;
            
            if (sortNumberA && sortNumberB) {
                return parseInt(sortNumberA) - parseInt(sortNumberB);
            }
            
            if (sortNumberA && !sortNumberB) {
                return -1;
            }

            if (!sortNumberA && sortNumberB) {
                return 1;
            }

            return 0;
        });
    }

    showMoreItems(blockIndex) {
        const block = this.blocks.find(b => b.index === blockIndex);
        if (!block) return;

        const hiddenItems = block.element.querySelectorAll('.flavors-list__hidden-item');

        hiddenItems.forEach(item => {
            item.style.display = '';
            item.classList.remove('flavors-list__hidden-item');
        });

        if (block.showMoreContainer) {
            block.showMoreContainer.style.display = 'none';
        }
    }

    applyHiddenPopularityFilter() {
        if (!this.flavorsContainer) return;
        
        const hasHiddenFilter = this.flavorsContainer.hasAttribute('data-hidden-popularity-filter') && this.flavorsContainer.getAttribute('data-hidden-popularity-filter') === 'true';
        const container = this.querySelector('.flavors-list__container');
        
        if (container) {
            if (hasHiddenFilter) {
                container.classList.add('hide-popularity-filter');
            } else {
                container.classList.remove('hide-popularity-filter');
            }
        }
    }

    restoreQuantitiesAfterFilter() {
        if (!this.selectedFlavors || Object.keys(this.selectedFlavors).length === 0) return;
        
        Object.keys(this.selectedFlavors).forEach(flavor => {
            const flavorData = this.selectedFlavors[flavor];
            const quantity = flavorData.count || flavorData;
            const productCard = this.querySelector(`[data-product-flavor="${flavor}"]`);
            
            if (productCard) {
                const allQtyInputs = productCard.querySelectorAll('[name="quantity"]');
                allQtyInputs.forEach(input => {
                    input.value = quantity;
                    if (quantity > 0) {
                        input.classList.add('is-active');
                    }
                });
                
                if (quantity > 0) {
                    productCard.classList.add('product-grid__item--active');
                    productCard.querySelectorAll('.quantity-minus').forEach(minusBtn => {
                        minusBtn.disabled = false;
                        minusBtn.classList.remove('button--js-disabled');
                    });
                    
                    const qtyInput = productCard.querySelector('[name="quantity"]');
                    if (qtyInput && qtyInput.hasAttribute('max')) {
                        const maxValue = Number(qtyInput.getAttribute('max'));
                        if (quantity >= maxValue) {
                            const allPlusBtns = productCard.querySelectorAll('.quantity-plus');
                            allPlusBtns.forEach(plusBtn => {
                                plusBtn.disabled = true;
                                plusBtn.classList.add('button--js-disabled');
                            });
                        }
                    }
                }
            }
        });
    }

    setLoading() {
        if(this.flavorsContainer) {
            this.flavorsContainer.classList.add('_loading');
            
            if (this.isInitialLoad) {
                requestAnimationFrame(() => {
                    this.flavorsContainer.classList.add('_loading');
                });
            }
        }
    }

    removeLoading() {
        if(this.flavorsContainer) {
            requestAnimationFrame(() => {
                this.flavorsContainer.classList.remove('_loading');
                this.isInitialLoad = false;
            });
        }
    }

    addSelectOptions() {
        if(this.flavorProfiles.length > 0 && this.flavorProfilesSelect) {
     
            const options = this.flavorProfiles.split(',').map(profile => 
                `<option value="${profile}">${profile}</option>`
            ).join('');
            
            this.flavorProfilesSelect.innerHTML = `<option value="">flavor profiles</option>${options}`;
            if (!this.flavorProfilesSlimSelect) {
                this.flavorProfilesSlimSelect = new SlimSelect({
                    select: '#flavor-profiles',
                    settings: {
                        showSearch: false,
                    },
                });
            }
            
            if (this.flavorProfilesContainer) {
                this.flavorProfilesContainer.style.display = 'block';
            }
        }
    }

    handleFlavorProfileChange() {
        this.flavorProfile = this.flavorProfilesSelect.value;
        this.getList(false);
    }

    handleQtyChanged() {
        if (!this.builderContent) return;
        
        // Remove old event listeners if they exist
        if (this.qtyChangeHandlersAttached) return;
        
        // Use event delegation on the main element instead of individual buttons
        this.addEventListener('click', (e) => {
            const plusBtn = e.target.closest('.product-card__actions .quantity-plus');
            if (plusBtn) {
                e.preventDefault();
                e.stopPropagation();
                this.handleAddFlavor(plusBtn);
                // Sync quantity selectors after add
                const qtyInput = plusBtn.closest('.quantity-selector').querySelector('[name="quantity"]');
                if (qtyInput) {
                    setTimeout(() => this.syncQuantitySelectors(qtyInput), 0);
                }
                return;
            }
            
            const minusBtn = e.target.closest('.product-card__actions .quantity-minus');
            if (minusBtn) {
                e.preventDefault();
                e.stopPropagation();
                const flavor = minusBtn.getAttribute('data-flavor');
                const blockList = this.builderContent.querySelectorAll(`.builder__block[data-flavor="${flavor}"]`);
                const block = blockList[blockList.length - 1];
                const qtyInput = minusBtn.closest('.quantity-selector').querySelector('[name="quantity"]');
                if(qtyInput && qtyInput.value === '0') {
                    minusBtn.closest('.product-grid__item').classList.remove('product-grid__item--active');
                    minusBtn.closest('.quantity-selector').querySelector('.quantity-minus').disabled = true;
                    minusBtn.closest('.quantity-selector').querySelector('.quantity-minus').classList.add('button--js-disabled');
                }
                this.removeFlavor(block, flavor);
                // Sync quantity selectors after remove
                if (qtyInput) {
                    setTimeout(() => this.syncQuantitySelectors(qtyInput), 0);
                }
                return;
            }
        });
        
        // Add synchronization for quantity inputs using event delegation
        this.addEventListener('input', (e) => {
            if (e.target.matches('.product-card__actions [name="quantity"]')) {
                this.syncQuantitySelectors(e.target);
            }
        });
        
        this.qtyChangeHandlersAttached = true;
    }

    syncQuantitySelectors(changedInput) {
        const productCard = changedInput.closest('.product-grid__item');
        if (!productCard) return;
        
        const allQtyInputs = productCard.querySelectorAll('[name="quantity"]');
        const newValue = changedInput.value;
        
        allQtyInputs.forEach(input => {
            if (input !== changedInput) {
                input.value = newValue;
            }
            
            // Sync is-active class for all inputs
            if (newValue > 0) {
                input.classList.add('is-active');
            } else {
                input.classList.remove('is-active');
            }
        });
    }

    handleAddFlavor(btn) {
        const flavor = btn.getAttribute('data-flavor');
        const flavorId = btn.getAttribute('data-product-id');
        const parentCard = btn.closest('.product-grid__item');
        let flavorImage = parentCard.querySelector('.product-media img').src;

        if(parentCard.querySelector('.product-card').dataset.bundleImg) {
            flavorImage = parentCard.querySelector('.product-card').dataset.bundleImg;
        }
        const inventoryGeorgetown = btn.closest('.quantity-selector').querySelector('[data-inventory-georgetown]').dataset.inventoryGeorgetown;
        const inventoryBethesda = btn.closest('.quantity-selector').querySelector('[data-inventory-bethesda]').dataset.inventoryBethesda;
        if(this.today === this.selectedDate) {
            if (inventoryGeorgetown && this.deliveryLocalLocationEl.value === 'georgetown') {
                if(this.selectedFlavors[flavor] && this.selectedFlavors[flavor].count + 1 > inventoryGeorgetown){
                    btn.disabled = true;
                    btn.classList.add('button--js-disabled');
                    return;
                }
            }
            if (inventoryBethesda && this.deliveryLocalLocationEl.value === 'bethesda') {
                if(this.selectedFlavors[flavor] && this.selectedFlavors[flavor].count + 1 > inventoryBethesda){
                    btn.disabled = true;
                    btn.classList.add('button--js-disabled');
                    return;
                }
            }
        }

        if(this.builderContent && this.builderContent.querySelector('.builder__block:not(.builder__block--active)')) {
            const block = this.builderContent.querySelector('.builder__block:not(.builder__block--active)');
            const fixedBlock = this.fixedBuilder.querySelector('.fixed-builder__block:not(.fixed-builder__block--active)');
            if (block) {
                block.classList.add('builder__block--active');
                const img = document.createElement('img');
                img.src = flavorImage;
                img.alt = flavor;
                block.appendChild(img);
                block.setAttribute('data-flavor', flavor);
            }
            if (fixedBlock) {
                fixedBlock.classList.add('fixed-builder__block--active');
                const fixedImg = document.createElement('img');
                fixedImg.src = flavorImage;
                fixedImg.alt = flavor;
                fixedBlock.appendChild(fixedImg);
                fixedBlock.setAttribute('data-flavor', flavor);
            }
            fixedBlock.setAttribute('data-flavor', flavor);
            if(this.selectedFlavors[flavor]) {
                this.selectedFlavors[flavor].count++
            } else {
                this.selectedFlavors[flavor] = {
                    count: 1,
                    id: flavorId
                };
            }
            parentCard.classList.add('product-grid__item--active');
            parentCard.querySelector('.quantity-minus').disabled = false;
            parentCard.querySelector('.quantity-minus').classList.remove('button--js-disabled');
            this.saveFlavors();
            this.validateAddToCart();
            this.updateFixedBuilder();
        }
    }

    validateAddToCart () {
        if (!this.addToCartBtn) return;
        
        const totalFlavors = Object.values(this.selectedFlavors || {}).reduce((sum, item) => sum + (item.count || item), 0);
        
        // Hide error messages when validating
        if(this.querySelector('.flavors-builder__out-of-stock-message')) {
            this.querySelector('.flavors-builder__out-of-stock-message').style.display = 'none';
        }
        if(this.querySelector('.flavors-builder__bundle-inventory-message')) {
            this.querySelector('.flavors-builder__bundle-inventory-message').style.display = 'none';
        }
        
        // Check delivery requirements
        const deliveryDate = this.deliveryDateEl?.value || localStorage.getItem('delivery-date');
        const deliveryZip = this.deliveryZipEl?.value || localStorage.getItem('delivery-zip');
        const deliveryLocation = this.deliveryLocalLocationEl?.value || localStorage.getItem('delivery-location');
        
        // For local delivery, check location; for nationwide, check zip
        const isDeliveryValid = this.type === 'local' 
            ? (deliveryDate && deliveryLocation)
            : (deliveryDate && deliveryZip && /^\d{5}$/.test(deliveryZip));
        
        const plusBtns = this.querySelectorAll('.product-card__actions .quantity-plus');
        
        if (totalFlavors < 12) {
            this.addToCartBtn.disabled = true;
            if(plusBtns.length > 0){
                plusBtns.forEach(btn => {
                    const qtyInput = btn.closest('.quantity-selector')?.querySelector('[name="quantity"]');
                    if (qtyInput && qtyInput.hasAttribute('max')) {
                        const currentValue = Number(qtyInput.value);
                        const maxValue = Number(qtyInput.getAttribute('max'));
                        if (currentValue >= maxValue) {
                            btn.disabled = true;
                            btn.classList.add('button--js-disabled');
                            return;
                        }
                    }
                    btn.disabled = false;
                    btn.classList.remove('button--js-disabled');
                });
            }
        } else {
            this.addToCartBtn.disabled = false;
            if(plusBtns.length > 0){
                plusBtns.forEach(btn => {
                    btn.disabled = true;
                    btn.classList.add('button--js-disabled');
                });
            }
        }
    }

    handleRemoveFlavor() {
        const removeBtn = this.querySelectorAll('.builder__remove');
        if (removeBtn.length > 0) {
            removeBtn.forEach(btn => {
                btn.addEventListener('click', () => {
                    const block = btn.closest('.builder__block');
                    const flavor = block.getAttribute('data-flavor');
                    const productCard = this.querySelector(`[data-product-flavor="${flavor}"]`);
                    const qtyInput = productCard?.querySelector('[name="quantity"]');
                    this.removeFlavor(block, flavor);
                    if (qtyInput) {
                        qtyInput.value = Number(qtyInput.value) - 1;
                        // Sync all quantity inputs in the product card
                        const allQtyInputs = productCard.querySelectorAll('[name="quantity"]');
                        allQtyInputs.forEach(input => {
                            input.value = qtyInput.value;

                            if (qtyInput.value < 1) {
                                input.classList.remove('is-active');
                            }
                        });
                        
                        if (qtyInput.hasAttribute('max')) {
                            const currentValue = Number(qtyInput.value);
                            const maxValue = Number(qtyInput.getAttribute('max'));
                            if (currentValue < maxValue) {
                                const allPlusBtns = productCard.querySelectorAll('.quantity-plus');
                                allPlusBtns.forEach(plusBtn => {
                                    plusBtn.disabled = false;
                                    plusBtn.classList.remove('button--js-disabled');
                                });
                            }
                        }
                    }
              
                    if(qtyInput && qtyInput.value === '0') {
                        qtyInput.closest('.product-grid__item').classList.remove('product-grid__item--active');
                        qtyInput.closest('.quantity-selector').querySelector('.quantity-minus').disabled = true;
                        qtyInput.closest('.quantity-selector').querySelector('.quantity-minus').classList.add('button--js-disabled');
                    }
                });
            });
        }
    }

    removeFlavor(block, flavor) {
        if (block) {
            block.classList.remove('builder__block--active');
            const img = block.querySelector('img');
            if (img) img.remove();
            block.removeAttribute('data-flavor');
            if(this.selectedFlavors[flavor].count) {
                this.selectedFlavors[flavor].count--;
                if(this.selectedFlavors[flavor].count === 0) {
                    delete this.selectedFlavors[flavor];
                }
            } else {
                this.selectedFlavors[flavor]--;
                if(this.selectedFlavors[flavor] === 0) {
                    delete this.selectedFlavors[flavor];             
                }
            }
            const fixedBlock = this.fixedBuilder.querySelector('.fixed-builder__block--active[data-flavor="' + flavor + '"]');
          
            if (fixedBlock) {
                fixedBlock.classList.remove('fixed-builder__block--active');
                const fixedImg = fixedBlock.querySelector('img');
                if (fixedImg) fixedImg.remove();
                fixedBlock.removeAttribute('data-flavor');
            }
            
            this.saveFlavors();
            this.validateAddToCart();
            this.updateFixedBuilder(); 
        }
    }

    saveFlavors() {
        localStorage.setItem('selectedFlavors', JSON.stringify(this.selectedFlavors));
    }

    handleClear(save) {
        this.querySelectorAll('.builder__block--active').forEach(block => {
            block.classList.remove('builder__block--active');
            const img = block.querySelector('img');
            if (img) img.remove();
            block.removeAttribute('data-flavor');
        });
        this.querySelectorAll('.product-card-wrapper .quantity-selector input[type=number]').forEach(item => {
            item.classList.remove('is-active');
        });
        this.querySelectorAll('.fixed-builder__block--active').forEach(block => {
            block.classList.remove('fixed-builder__block--active');
            const img = block.querySelector('img');
            if (img) img.remove();
            block.removeAttribute('data-flavor');
        });
        this.selectedFlavors = {};
    
        this.querySelectorAll('.product-grid [name="quantity"]').forEach(input => {
            input.value = 0;
            input.closest('.product-grid__item').classList.remove('product-grid__item--active');
            input.closest('.quantity-selector').querySelector('.quantity-minus').disabled = true;
            input.closest('.quantity-selector').querySelector('.quantity-minus').classList.add('button--js-disabled');
        });
        this.updateFixedBuilder();
        if(save){
            this.validateAddToCart();
            this.saveFlavors();
        }
        if(this.mysteryBoxButton) {
            this.mysteryBoxButton.classList.remove('button-disabled')
        }

        if( this.querySelector('.flavors-builder__out-of-stock-message')) {
            this.querySelector('.flavors-builder__out-of-stock-message').style.display = 'none';
        }
        if( this.querySelector('.flavors-builder__bundle-inventory-message')) {
            this.querySelector('.flavors-builder__bundle-inventory-message').style.display = 'none';
        }
    }

    resetFlavors() {
        this.selectedFlavors = JSON.parse(localStorage.getItem('selectedFlavors') || '{}');
        this.minusBtns = this.querySelectorAll('.product-card__actions .quantity-minus');
        this.minusBtns.forEach(btn => {
            btn.disabled = true;
            btn.classList.add('button--js-disabled');
        });
        if(!this.builderContent) return;
        this.fixedBuilder.style.display = '';
        
        // Check inventory for current location and remove unavailable products
        const currentLocation = this.deliveryLocalLocationEl?.value;
        const flavorsToRemove = [];
        
        Object.keys(this.selectedFlavors).forEach(flavor => {
            const flavorData = this.selectedFlavors[flavor];
            const quantity = flavorData.count || flavorData; 
            const productCard = this.querySelector(`[data-product-flavor="${flavor}"]`);
            
            // If product card not found, mark for removal
            if (!productCard) {
                flavorsToRemove.push(flavor);
                return;
            }
            
            // Check if product is out of stock for current location (only for today's date)
            if (currentLocation && this.type === 'local' && this.today === this.selectedDate) {
                const inventoryAttr = currentLocation === 'georgetown' ? 'data-inventory-georgetown' : 'data-inventory-bethesda';
                const inventoryElement = productCard.querySelector(`[${inventoryAttr}]`);
                const inventory = inventoryElement ? Number(inventoryElement.getAttribute(inventoryAttr)) : 0;
                
                if (inventory === 0) {
                    flavorsToRemove.push(flavor);
                    return;
                }
            }
            
            if (productCard) {
                let flavorImage = productCard.querySelector('.product-media img').src;
                if(productCard.querySelector('.product-card').dataset.bundleImg) {
                    flavorImage = productCard.querySelector('.product-card').dataset.bundleImg;
                }
                const qtyInput = productCard.querySelector('[name="quantity"]');
                if (qtyInput) {
                    qtyInput.value = quantity;
                    // Sync all quantity inputs in the product card
                    const allQtyInputs = productCard.querySelectorAll('[name="quantity"]');
                    allQtyInputs.forEach(input => {
                        input.value = quantity;
                        // Add is-active class if quantity > 0
                        if (quantity > 0) {
                            input.classList.add('is-active');
                        }
                    });
                    qtyInput.closest('.product-grid__item').classList.add('product-grid__item--active');
                    qtyInput.closest('.product-grid__item').querySelectorAll('.quantity-selector .quantity-minus').forEach(minusBtn => {
                        minusBtn.disabled = false;
                        minusBtn.classList.remove('button--js-disabled');
                    });
                    
                    if (qtyInput.hasAttribute('max')) {
                        const maxValue = Number(qtyInput.getAttribute('max'));
                        if (quantity >= maxValue) {
                            const allPlusBtns = productCard.querySelectorAll('.quantity-plus');
                            allPlusBtns.forEach(plusBtn => {
                                plusBtn.disabled = true;
                                plusBtn.classList.add('button--js-disabled');
                            });
                        }
                    }
                }
            
                for (let i = 0; i < quantity; i++) {
                    const block = this.builderContent.querySelector('.builder__block:not(.builder__block--active)');
                    const fixedBlock = this.fixedBuilder.querySelector('.fixed-builder__block:not(.fixed-builder__block--active)');
                    if (block) {
                        block.classList.add('builder__block--active');
                        const img = document.createElement('img');
                        img.src = flavorImage;
                        img.alt = flavor;
                        block.appendChild(img);
                        block.setAttribute('data-flavor', flavor);
                    }
                    if (fixedBlock) {
                        fixedBlock.classList.add('fixed-builder__block--active');
                        const fixedImg = document.createElement('img');
                        fixedImg.src = flavorImage;
                        fixedImg.alt = flavor;
                        fixedBlock.appendChild(fixedImg);
                        fixedBlock.setAttribute('data-flavor', flavor);
                    }

                }
                if(flavor === 'Mystery Box') {
                    this.fixedBuilder.style.display = 'none';   
                    const removeBtn = this.querySelectorAll('.builder__remove');
                    removeBtn.forEach(button => {
                        button.style.display = 'none';
                    })
                    this.fixedBuilder.style.display = 'none';
                    this.mysteryBoxButton.classList.add('button-disabled');
                }
            }
        });
        
        // Remove unavailable products from selectedFlavors
        flavorsToRemove.forEach(flavor => {
            delete this.selectedFlavors[flavor];
        });
        
        this.saveFlavors();
        this.validateAddToCart();
        this.updateFixedBuilder();
    }

    initStickyBuilder() {
        this.fixedBuilder = document.querySelector('.fixed-builder');
        if(!this.fixedBuilder) return;
        this.fixedBuilderCounter = document.querySelector('.js-fixed-builder-counter');
        this.fixedBuilderProgressBar = document.querySelector('.js-fixed-builder-progress-bar');
        this.fixedBuilderBlocks = document.querySelectorAll('.js-fixed-builder-block');
        this.flavorsBuilder = document.querySelector('.flavors-builder');
        
        if (this.fixedBuilder && this.flavorsBuilder && window.innerWidth > 1200) {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.target === this.flavorsBuilder) {
                        const isVisible = entry.isIntersecting;
                        if (!isVisible) {
                            this.fixedBuilder.classList.add('fixed-builder--visible');
                        } else {
                            this.fixedBuilder.classList.remove('fixed-builder--visible');
                        }
                    }
                });
            }, {
                threshold: 0,
                rootMargin: '0px 0px -100px 0px' 
            });
            this.observer.observe(this.flavorsBuilder);
        }
    }


    updateFixedBuilder() {
        if (!this.fixedBuilderCounter || !this.fixedBuilderProgressBar) return;
        
        const totalSelected = Object.values(this.selectedFlavors).reduce((sum, item) => sum + (item.count || item), 0);
        
        const totalSelectedStr = String(totalSelected);
        if (this.fixedBuilderCounter.textContent !== totalSelectedStr) {
            this.fixedBuilderCounter.textContent = totalSelectedStr;
        }
        
        const progressPercentage = Math.min((totalSelected / 12) * 100, 100);
        const progressStr = `${progressPercentage}%`;
        if (this.fixedBuilderProgressBar.style.width !== progressStr) {
            this.fixedBuilderProgressBar.style.width = progressStr;
        }
    }

    async waitForCartEmpty(timeout = 20000, interval = 500) {
        const start = Date.now();
        while (Date.now() - start < timeout) {
            try {
                const cart = await fetch('/cart.js').then(res => res.json());
                if (cart && Array.isArray(cart.items) && cart.items.length === 0) return true;
            } catch (err) {
                // ignore and retry
            }
            await new Promise(r => setTimeout(r, interval));
        }
        return false;
    }

    saveToggleButtonState() {
        const toggleButtonContainer = this.querySelector('.js-view-your-box-container');
        if (toggleButtonContainer) {
            this.toggleButtonSavedDisplay = toggleButtonContainer.style.display;
        }
    }

    restoreToggleButtonState() {
        const toggleButtonContainer = this.querySelector('.js-view-your-box-container');
        if (toggleButtonContainer && this.toggleButtonSavedDisplay !== undefined) {
            toggleButtonContainer.style.display = this.toggleButtonSavedDisplay;
        }
    }

    async handleAddToCart() {
        // Save current state of toggle button before add to cart on iOS
        this.saveToggleButtonState();
        
        const outOfStock = [];
        let body = {};
        const productId = this.addToCartBtn.getAttribute('data-product-id');
        const quantity = this.querySelector('.flavors-builder__product-actions [name="quantity"]').value;
        const currentCart = await fetch('/cart.js').then(res => res.json());
        const currentType = currentCart.attributes?.type || null;
        const activeType = currentCart.attributes?.activeType || null;
        const deliveryDate = this.deliveryDateEl ? this.deliveryDateEl.value : '';
        
        if(!this.selectedFlavors['Mystery Box']) {
            if(this.today === deliveryDate && this.type !== 'nationwide') {
                const attributeName = this.deliveryLocalLocationEl.value === 'bethesda' ? 'data-inventory-bethesda' : 'data-inventory-georgetown';
                Object.keys(this.selectedFlavors).forEach(flavor => {
                    const flavorData = this.selectedFlavors[flavor];
                    const flavorId = flavorData.id;
                    const flavorCount = flavorData.count * quantity || 0;
                    
                    if (flavorId) {
                        const flavorElement = document.querySelector(`[data-variant-id="${flavorId}"]`);
                        if (flavorElement) {
                            const inventory = +flavorElement.getAttribute(attributeName) || 0;
                            if (flavorCount > inventory) {
                                outOfStock.push(flavorData.flavor);
                            }
                        }
                    }
                });
            }
            if(outOfStock.length > 0) {
                this.addToCartBtn.disabled = true;
                this.addToCartBtn.classList.add('button--disabled');
                if(this.querySelector('.flavors-builder__out-of-stock-message')) {
                    this.querySelector('.flavors-builder__out-of-stock-message').style.display = 'block';
                }
                return;
            }
            body = {
                id: productId,
                quantity: quantity,
                properties: {
                    _flavors: Object.keys(this.selectedFlavors).map(flavor => {
                        const flavorData = this.selectedFlavors[flavor];
                        const count = flavorData.count || flavorData;
                        return `${flavor}: ${count}`;
                    }).join('//'),
                    _flavorIds: Object.keys(this.selectedFlavors).map(flavor => {
                        const flavorData = this.selectedFlavors[flavor];
                        return flavorData.id || ''; 
                    }).filter(id => id).join(','),
                    _uniqueId: Date.now().toString(),
                    _availableMonth: this.selectedMonth,
                    deliveryDate: deliveryDate,
                    deliveryZip: this.deliveryZipEl ? this.deliveryZipEl.value : '',

                },
                attributes: {
                    activeType: this.type
                }
            }

        } else {
            body = {
                id: productId,
                quantity: quantity,
                properties: {
                    _flavors: 'Mystery Box',
                    _flavorIds: '',
                    _uniqueId: Date.now().toString(),
                    deliveryDate: deliveryDate,
                    deliveryZip: this.deliveryZipEl ? this.deliveryZipEl.value : '',
                },
                attributes: {
                    activeType: this.type
                }
            }
        }
    
        if(this.type === 'local') {
            body.properties['deliveryTime'] = this.deliveryTimeEl ? this.deliveryTimeEl.value : '';
            body.properties['deliveryLocalLocation'] = this.deliveryLocalLocationEl ? this.deliveryLocalLocationEl.value : '';
            body.properties['deliveryLocalType'] = document.querySelector('[name="delivery-type"]') ? document.querySelector('[name="delivery-type"]:checked').value : '';
        }

        if(this.type === 'local') {
            body.properties['_availableDay'] = this.dayOfWeek;
        } 

        if (activeType && currentType && activeType !== currentType && currentCart.items.length > 0) {
            document.dispatchEvent(new CustomEvent('open-purchase-blocking-popup'));
            
            // Prevent multiple retry handlers for the same method call
            const retryKey = 'handleAddToCart';
            if (this.pendingRetries.has(this) && this.pendingRetries.get(this) === retryKey) return;
            this.pendingRetries.set(this, retryKey);
            
            const clearClickHandler = async (e) => {
                if (!e.target) return;
                const el = e.target.closest && e.target.closest('.js-cart-clear');
                if (!el) return;
                
                document.removeEventListener('click', clearClickHandler);
                
                const emptied = await this.waitForCartEmpty(20000, 500);
                this.pendingRetries.delete(this);
                
                if (emptied) {
                    setTimeout(() => {
                        this.handleAddToCart();
                    }, 300);
                }
            };
            
            document.addEventListener('click', clearClickHandler);
            return;
        }
        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then((response) => response.json())
        .then((cart) => {
            let isAvailable = true;
            const flavorsList = {};
            const currentLocation = this.deliveryLocalLocationEl ? this.deliveryLocalLocationEl.value : '';

            // Only check inventory for today's date (flavors are not merch products)
            if (this.today === deliveryDate) {
                if (cart.items.length > 0) {
                    cart.items.forEach((item) => {
                        // For local delivery, only count items from the same location
                        if (this.type === 'local') {
                            const itemLocation = item.properties?.deliveryLocalLocation;
                            if (itemLocation !== currentLocation) {
                                return;
                            }
                        }

                        // Bundle items with _flavors property
                        if (item.properties?._flavors && item.properties?._flavorIds) {
                            const flavors = item.properties._flavors.split('//');
                            
                            flavors.forEach((flavor) => {
                                const flavorArr = flavor.split(': ');
                                const flavorName = flavorArr[0];
                                const flavorQtyInBundle = Number(flavorArr[1]) || 0;
                                const totalQty = flavorQtyInBundle * item.quantity;
                                flavorsList[flavorName] = (flavorsList[flavorName] || 0) + totalQty;
                            });
                        } else if (item.properties?.['_itemType'] === 'flavor') {
                           flavorsList[item.title] = (flavorsList[item.title] || 0) + Number(item.quantity);
                        }
                    })
                }
            
                // Check if adding these bundles would exceed inventory
                Object.keys(this.selectedFlavors).forEach(flavor => {
                    const flavorData = this.selectedFlavors[flavor];
                    
                    let attributeName;
                    if (this.type === 'nationwide') {
                        attributeName = 'data-inventory-nationwide';
                    } else {
                        attributeName = this.deliveryLocalLocationEl.value === 'bethesda' ? 'data-inventory-bethesda' : 'data-inventory-georgetown';
                    }
                    
                    const flavorElement = document.querySelector(`[data-variant-id="${flavorData.id}"]`);
                    
                    if (flavorElement) {
                        const inventory = +flavorElement.getAttribute(attributeName) || 0;
                        const flavorCountInNewBundles = flavorData.count * quantity;
                        const flavorCountInCart = flavorsList[flavor] || 0;
                        const totalFlavorCount = flavorCountInNewBundles + flavorCountInCart;
                        
                        if (totalFlavorCount > inventory) {
                            isAvailable = false;
                        }
                    }
                })
            }

            if(!isAvailable) {
                const bundleInventoryMsg = this.querySelector('.flavors-builder__bundle-inventory-message');
                if (bundleInventoryMsg) {
                    const listEl = bundleInventoryMsg.querySelector('.flavors-builder__bundle-inventory-list');
                    if (listEl) {
                        listEl.innerHTML = '';
                        
                        // Collect all flavors that exceed inventory
                        const unavailableFlavors = [];
                        Object.keys(this.selectedFlavors).forEach(flavor => {
                            const flavorData = this.selectedFlavors[flavor];
                            
                            let attributeName;
                            if (this.type === 'nationwide') {
                                attributeName = 'data-inventory-nationwide';
                            } else {
                                attributeName = this.deliveryLocalLocationEl.value === 'bethesda' ? 'data-inventory-bethesda' : 'data-inventory-georgetown';
                            }
                            
                            const flavorElement = document.querySelector(`[data-variant-id="${flavorData.id}"]`);
                            
                            if (flavorElement) {
                                const inventory = +flavorElement.getAttribute(attributeName) || 0;
                                const flavorCountInNewBundles = flavorData.count * quantity;
                                const flavorCountInCart = flavorsList[flavor] || 0;
                                const totalFlavorCount = flavorCountInNewBundles + flavorCountInCart;
                                
                                if(totalFlavorCount > inventory) {
                                    unavailableFlavors.push({
                                        name: flavor,
                                        needed: totalFlavorCount,
                                        available: inventory,
                                        shortage: totalFlavorCount - inventory
                                    });
                                }
                            }
                        });
                        
                        // Display each unavailable flavor
                        unavailableFlavors.forEach(item => {
                            const li = document.createElement('li');
                            li.textContent = `${item.name}: Need ${item.needed}, only ${item.available} available (short by ${item.shortage})`;
                            listEl.appendChild(li);
                        });
                    }
                    bundleInventoryMsg.style.display = 'block';
                }
                return;
            }
            fetch(Theme.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then((response) => response.json())
                .then((response) => {
                if (response.status) {
                    this.dispatchEvent(
                    new CartErrorEvent(form.getAttribute('id') || '', response.message, response.description, response.errors)
                    );
                } else {
                    this.dispatchEvent(new CartAddEvent());
                    this.handleClear(true);
                    
                    // Hide both error messages on success
                    if(this.querySelector('.flavors-builder__out-of-stock-message')) {
                        this.querySelector('.flavors-builder__out-of-stock-message').style.display = 'none';
                    }
                    if(this.querySelector('.flavors-builder__bundle-inventory-message')) {
                        this.querySelector('.flavors-builder__bundle-inventory-message').style.display = 'none';
                    }
                    
                    // Update loyalty points widget
                    if (typeof window.updateLoyaltyPointsText === 'function') {
                        window.updateLoyaltyPointsText();
                    }
                    
                    // Restore toggle button state after cart add completes (iOS fix)
                    setTimeout(() => {
                        this.restoreToggleButtonState();
                    }, 500);
                }
                
            });
        })
    }
    handleFlavorQtyChanged(el) {
        const qtyInputs = el.closest('quantity-selector-component').querySelectorAll('[name="quantity"]');
        qtyInputs.forEach(input => {
            if(input.value > 0) {
                el.closest('.product-grid__item').classList.add('product-grid__item--active');
                el.closest('.product-grid__item').querySelectorAll('.quantity-selector .quantity-minus').forEach(minusBtn => {
                    minusBtn.disabled = false;
                    minusBtn.classList.remove('button--js-disabled');
                });
            } else {
                el.closest('.product-grid__item').classList.remove('product-grid__item--active');
                el.closest('.product-grid__item').querySelectorAll('.quantity-selector .quantity-minus').forEach(minusBtn => {
                    minusBtn.disabled = true;
                    minusBtn.classList.add('button--js-disabled');
                })
            }
        })
    }

    async handleCardsAddToCart(e) {
        // Save current state of toggle button before add to cart on iOS
        this.saveToggleButtonState();
        
        const productId = e.target.getAttribute('data-product-id');
        const qtyElement = e.target.closest('.product-card__actions').querySelector('[name="quantity"]');
        const quantity = qtyElement.value;
        const location = this.deliveryLocalLocationEl ? this.deliveryLocalLocationEl.value : '';
        const availableQty = qtyElement.getAttribute(`data-inventory-${location}`);
        const activeItem = e.target.closest('.product-grid__item');
        if (quantity <= 0) return;

        const currentCart = await fetch('/cart.js').then(res => res.json());
        const currentType = currentCart.attributes?.type || null;
        const activeType = currentCart.attributes?.activeType || null;

        if (activeType && currentType && activeType !== currentType && currentCart.items.length > 0) {
            document.dispatchEvent(new CustomEvent('open-purchase-blocking-popup'));
            
            const retryKey = `handleCardsAddToCart-${productId}`;
            if (this.pendingRetries.has(this) && this.pendingRetries.get(this) === retryKey) return;
            this.pendingRetries.set(this, retryKey);
            
            const clearClickHandler = async (ev) => {
                if (!ev.target) return;
                const el = ev.target.closest && ev.target.closest('.js-cart-clear');
                if (!el) return;
                
                document.removeEventListener('click', clearClickHandler);
                
                const emptied = await this.waitForCartEmpty(20000, 500);
                this.pendingRetries.delete(this);
                
                if (emptied) {
                    setTimeout(() => {
                        this.handleCardsAddToCart(e);
                    }, 300);
                }
            };
            
            document.addEventListener('click', clearClickHandler);
            return;
        }

        const body = {
            id: productId,
            quantity: quantity,
            properties: {
                _availableMonth: this.selectedMonth,
                _itemType: 'flavor',
                deliveryDate: this.deliveryDateEl ? this.deliveryDateEl.value : '',
                deliveryZip: this.deliveryZipEl ? this.deliveryZipEl.value : '',
            },
            attributes: {
                activeType: currentType || this.type || ""
            }
        }

        if(this.type === 'local') {
            body.properties['_availableDay'] = this.dayOfWeek;
            body.properties['deliveryTime'] = this.deliveryTimeEl ? this.deliveryTimeEl.value : '';
            body.properties['deliveryLocalLocation'] = this.deliveryLocalLocationEl ? this.deliveryLocalLocationEl.value : '';
            body.properties['deliveryLocalType'] = document.querySelector('[name="delivery-type"]:checked') ? document.querySelector('[name="delivery-type"]:checked').value : '';
        }
        

        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then((response) => response.json())
        .then((cart) => {
            if(cart.items.length > 0 && this.type === 'local' && this.today === this.selectedDate) {
              cart.items.forEach((item) => {
                if(item.id === productId && item.properties['deliveryDate'] === this.today) {
                  if((availableQty + quantity) <= item.quantity) {
                    const popup = document.querySelector('.js-popup-inventory');
                    popup.classList.remove('hidden');
                    popup.querySelector('.js-popup-text').textContent = availableQty;
                    return;
                  }
                }
              })
            } 

            fetch(Theme.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then((response) => response.json())
                .then((response) => {
                if (response.status) {
                    this.dispatchEvent(
                    new CartErrorEvent(form.getAttribute('id') || '', response.message, response.description, response.errors)
                    );
                } else {
                    //this.checkBundle();
                    this.dispatchEvent(new CartAddEvent());
                    this.handleClear(true);
                    activeItem.classList.remove('product-grid__item--active');
                    activeItem.querySelectorAll('.quantity-minus').forEach(minusBtn => {
                        minusBtn.disabled = true;
                        minusBtn.classList.add('button--js-disabled');
                    });
                    activeItem.querySelectorAll('[name="quantity"]').forEach(qtyInput => {
                        qtyInput.value = 0;
                    });
                    
                    // Update loyalty points widget
                    if (typeof window.updateLoyaltyPointsText === 'function') {
                        window.updateLoyaltyPointsText();
                    }
                    
                    // Restore toggle button state after cart add completes (iOS fix)
                    setTimeout(() => {
                        this.restoreToggleButtonState();
                    }, 500);
                }
                
            });
        });
        
    }
    
    checkBundle() {
        const currentType = document.querySelector('[data-cart-type]')?.getAttribute('data-cart-type');
        if(currentType && currentType !== this.type) {
            document.dispatchEvent(new CustomEvent('open-purchase-blocking-popup'));
            
            const retryKey = 'checkBundle';
            if (this.pendingRetries.has(this) && this.pendingRetries.get(this) === retryKey) return;
            this.pendingRetries.set(this, retryKey);
            
            const clearClickHandler = async (e) => {
                if (!e.target) return;
                const el = e.target.closest && e.target.closest('.js-cart-clear');
                if (!el) return;
                
                document.removeEventListener('click', clearClickHandler);
                
                const emptied = await this.waitForCartEmpty(20000, 500);
                this.pendingRetries.delete(this);
                
                if (emptied) {
                    setTimeout(() => {
                        //this.checkBundle();
                    }, 300);
                }
            };
            
            document.addEventListener('click', clearClickHandler);
            return;
        }
       fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            if(cart.items.length > 0) {
                const cartObject = {};
                cart.items.reverse().forEach((item) => {
                    if(item.handle !== 'custom-dozen' && item.properties._itemType === 'flavor'){
                        const deliveryDate = item.properties.deliveryDate || '';
                        const deliveryZip = item.properties.deliveryZip || '';
                        const deliveryLocalLocation = item.properties.deliveryLocalLocation || '';
                        const deliveryLocalType = item.properties.deliveryLocalType || '';
                        
                        const groupKey = `${deliveryDate}|${deliveryZip}|${deliveryLocalLocation}|${deliveryLocalType}`;
                        
                        if(!cartObject[groupKey]) {
                            cartObject[groupKey] = [];
                            cartObject[groupKey].push(item);
                        } else {
                            cartObject[groupKey].push(item);
                        }
                    }
                })
                Object.keys(cartObject).map(groupKey => {
                    let groupQty = 0;
                    cartObject[groupKey].forEach(item => {
                        groupQty += item.quantity;
                    })

                    if(groupQty >= 12){
                        this.generateBundle(cartObject[groupKey])
                    }
                })
            }
        })
    }

    generateBundle(items) {
        const currentType = document.querySelector('[data-cart-type]')?.getAttribute('data-cart-type');
        if(currentType && currentType !== this.type) {
            document.dispatchEvent(new CustomEvent('open-purchase-blocking-popup'));
            
            const retryKey = `generateBundle-${Date.now()}`;
            if (this.pendingRetries.has(this) && this.pendingRetries.get(this).startsWith('generateBundle')) return;
            this.pendingRetries.set(this, retryKey);
            
            const clearClickHandler = async (e) => {
                if (!e.target) return;
                const el = e.target.closest && e.target.closest('.js-cart-clear');
                if (!el) return;
                
                document.removeEventListener('click', clearClickHandler);
                
                const emptied = await this.waitForCartEmpty(20000, 500);
                this.pendingRetries.delete(this);
                
                if (emptied) {
                    setTimeout(() => {
                        this.generateBundle(items);
                    }, 300);
                }
            };
            
            document.addEventListener('click', clearClickHandler);
            return;
        }
        const self = this;
        let totalQty = 0;
        let flavors = [];
        let ids = [];
        let bundledFlavors = [];
        let partBundledItem;
        let partBundledQty;
        items.forEach(item => {
            if(totalQty < 12){
                if(totalQty + item.quantity <= 12) {
                    totalQty += item.quantity;
                    flavors.push(`${item.title}:${item.quantity}`);
                    ids.push(item.variant_id);
                    bundledFlavors.push(item);
                } else {
                    partBundledItem = item;
                    partBundledQty = 12 - totalQty;
                    flavors.push(`${item.title}:${partBundledQty}`);
                    ids.push(item.variant_id)
                }
            }
        })

        const updates = {};
        let additionalBundlesQty = 0;
        let remainder = 0
        bundledFlavors.forEach(item => {
            updates[item.key] = 0;
        })
        if(partBundledItem && partBundledItem.quantity - partBundledQty > 12) {
            additionalBundlesQty = Math.floor((partBundledItem.quantity - partBundledQty) / 12);
            remainder = (partBundledItem.quantity - partBundledQty) % 12;
        }
        if(partBundledItem && additionalBundlesQty === 0) {
            updates[partBundledItem.key] = partBundledItem.quantity - partBundledQty;
        } else if(partBundledItem && additionalBundlesQty > 0) {
            updates[partBundledItem.key] = remainder;
        }
   
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        .then(res => res.json())
        .then(cart => {
            const firstItem = items[0];
            const deliveryProperties = {
                _availableMonth: firstItem.properties._availableMonth || '',
                _uniqueId: Date.now().toString(),
                deliveryDate: firstItem.properties.deliveryDate || '',
                deliveryZip: firstItem.properties.deliveryZip || '',
                deliveryTime: firstItem.properties.deliveryTime || '',
                deliveryLocalLocation: firstItem.properties.deliveryLocalLocation || '',
                deliveryLocalType: firstItem.properties.deliveryLocalType || '',
            };
            
            const body = {
                items: [{
                    id: CUSTOM_DOZEN_VARIANT_ID,
                    quantity: 1,
                    properties: {
                        _flavors: flavors.join('//'),
                        _flavorIds: ids.join(','),
                        _type: this.type,
                        ...deliveryProperties
                    },
                    attributes: {
                        activeType: this.type
                    }
                }]
            }
            if(additionalBundlesQty > 0) {
                body.items.push({
                    id: CUSTOM_DOZEN_VARIANT_ID,
                    quantity: additionalBundlesQty,
                    properties: {
                        _flavors: `${partBundledItem.title}:12`,
                        _type: this.type,
                        ...deliveryProperties
                    },
                    attributes: {
                        activeType: this.type
                    }
                })
            }
            
            
            fetch(Theme.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then((response) => response.json())
                .then((response) => {
                if (response.status) {
                    self.dispatchEvent(
                    new CartErrorEvent(form.getAttribute('id') || '', response.message, response.description, response.errors)
                    );
                } else {
                    self.dispatchEvent(new CartAddEvent());
                    self.handleClear(true);
                    
                    // Update loyalty points widget
                    if (typeof window.updateLoyaltyPointsText === 'function') {
                        window.updateLoyaltyPointsText();
                    }
                }
                
            });
        });
    }
    initToggleButtonObserver() {
        const toggleButtonContainer = this.querySelector('.js-view-your-box-container');
        const builderElement = this.querySelector('.flavors-builder__row');
        if (!toggleButtonContainer) return;
        
        if (window.innerWidth >= 1200) {
            toggleButtonContainer.style.display = 'none';
            return;
        }
        
        // Toggle between header sticky state and delivery selector visibility
        const useHeaderStickyState = true;
        
        if (useHeaderStickyState) {
            const header = document.querySelector('#header-component');
            if (!header) return;
            
            const headerObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-sticky-state') {
                        const stickyState = header.getAttribute('data-sticky-state');
                        if (stickyState === 'active') {
                            if (!builderElement.classList.contains('flavors-builder__row--active')) {
                                toggleButtonContainer.style.display = 'block';
                            }
                        } else {
                            toggleButtonContainer.style.display = 'none';
                        }
                    }
                });
            });
            
            headerObserver.observe(header, {
                attributes: true,
                attributeFilter: ['data-sticky-state']
            });
            
            // Initial check
            const initialState = header.getAttribute('data-sticky-state');
            if (initialState === 'active' && !builderElement.classList.contains('flavors-builder__row--active')) {
                toggleButtonContainer.style.display = 'block';
            } else {
                toggleButtonContainer.style.display = 'none';
            }
        } else {
            const deliverySelector = document.querySelector('delivery-selector');
            if (!deliverySelector) return;
            
            this.toggleObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.target === deliverySelector) {
                        if (entry.isIntersecting) {
                            if(!builderElement.classList.contains('flavors-builder__row--active')) {
                                toggleButtonContainer.style.display = 'none';
                            }
                        } else {
                            toggleButtonContainer.style.display = 'block';
                        }
                    }
                });
            }, {
                threshold: 0,
                rootMargin: '0px'
            });
            
            this.toggleObserver.observe(deliverySelector);
        }
    }

    handleViewYourBox() {
        const builderElement = this.querySelector('.flavors-builder__row');
        builderElement.classList.toggle('flavors-builder__row--active');
        if(builderElement.classList.contains('flavors-builder__row--active')) {
           document.body.classList.add('overflow-hidden'); 
        } else {
            document.body.classList.remove('overflow-hidden');
        }
        this.querySelector('.js-view-your-box').classList.toggle('flavors-builder__toggle-button--active');

    }

    handleMysteryBoxAdd(btn) {
        localStorage.removeItem('selectedFlavors');
        const parentCard = btn.closest('.product-grid__item');
        let flavorImage = parentCard.querySelector('.product-media img').src;
        this.handleClear();
        const blocks = this.builderContent.querySelectorAll('.builder__block');
        blocks.forEach(block => {
            block.classList.add('builder__block--active');
            const img = document.createElement('img');
            img.src = flavorImage;
            img.alt = 'Mystery Box';
            block.appendChild(img);
            block.setAttribute('data-flavor', 'Mystery Box');
        })
          
        const removeBtn = this.querySelectorAll('.builder__remove');
        removeBtn.forEach(button => {
            button.style.display = 'none';
        })
        this.fixedBuilder.style.display = 'none';
        btn.classList.add('button-disabled');
        
        this.selectedFlavors['Mystery Box'] = {
            count: 12,
            id: 'Mystery Box'
        }

        this.saveFlavors();
        this.validateAddToCart();
    }

    initTooltips() {
        const tooltipTriggers = this.querySelectorAll('[data-tooltip]');
        
        tooltipTriggers.forEach(trigger => {
            const tooltip = trigger.querySelector('.product-card__tooltip');
            if (!tooltip) return;

            let hideTimeout;

            const showTooltip = () => {
                clearTimeout(hideTimeout);
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            };

            const hideTooltip = () => {
                hideTimeout = setTimeout(() => {
                    tooltip.style.opacity = '0';
                    tooltip.style.visibility = 'hidden';
                }, 100);
            };

            trigger.addEventListener('mouseenter', showTooltip);
            trigger.addEventListener('mouseleave', hideTooltip);
            trigger.addEventListener('focus', showTooltip);
            trigger.addEventListener('blur', hideTooltip);

            trigger.addEventListener('touchstart', (e) => {
                e.preventDefault();
                showTooltip();
            });

            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const isVisible = tooltip.style.opacity === '1';
                if (isVisible) {
                    hideTooltip();
                } else {
                    showTooltip();
                }
            });
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('[data-tooltip]')) {
                tooltipTriggers.forEach(trigger => {
                    const tooltip = trigger.querySelector('.product-card__tooltip');
                    if (tooltip) {
                        tooltip.style.opacity = '0';
                        tooltip.style.visibility = 'hidden';
                    }
                });
            }
        });
    }

    setInventoryPopup() {
        const closeBtns = this.inventoryPopup.querySelectorAll('.js-close-popup');
        closeBtns.forEach(btn => btn.addEventListener('click', () => {
            this.inventoryPopup.classList.add('hidden');
        }));
    }
}

if (!customElements.get('flavors-list')) {
    customElements.define('flavors-list', Flavors);
}
